export default "__VITE_ASSET__0zWRY3JN__"